import { inject, Injectable } from '@angular/core';
import { filter, firstValueFrom } from 'rxjs';
import { AuthService, ProfileService } from '@tokenbox/services';
import { Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private readonly authService = inject(AuthService);
  private readonly profileService = inject(ProfileService);
  private readonly router = inject(Router);

  async canActivate(): Promise<boolean | UrlTree> {
    await this.authService.tryLoggingIn();
    await this.awaitSuccessfulUserLogin();
    const isProfileFullySetup = await this.profileService.isProfileFullySetup();
    return isProfileFullySetup
      ? true
      : this.router.parseUrl('/auth/setup-account');
  }

  private async awaitSuccessfulUserLogin() {
    await firstValueFrom(
      this.authService.isLoggedIn$.pipe(filter((isLoggedIn) => isLoggedIn)),
    );
  }
}
